<template>
  <div class="category-expanded-section">
    <div class="tree-category-row">
      <div class="left-column">
        <button class="icon-expand" @click="changeCategory(category)"></button>
      </div>

      <div class="right-column">
        <div class="title-row">
          <span class="icon icon-stream"></span>
          <span class="title-name">{{category.title}}</span>
        </div>
        <div class="cont-row" v-if="(required > 0 || taken > 0 || needed > 0) && showCategoryDetail">
          Courses - Required <span>{{required}}</span> / Taken <span>{{taken}}</span> / Needed <span>{{needed}}</span>
        </div>
        <div class="cont-row red-text" v-if="!showCategoryDetail">
          Minimum 18 quarter units in at least 2 of the following areas: Arts, Humanities, Foreign Language
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'category',
  props: ['category'],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadCategory'
    ]),
    changeCategory (category) {
      this.loadCategory(category)
    }
  },

  computed: {
    ...mapState({
      'stream': state => state.stream.stream
    }),
    showCategoryDetail () {
      if (this.category.title.indexOf('Arts') > -1 || this.category.title.indexOf('Humanities') > -1 || this.category.title.indexOf('Foreign ') > -1) {
        if (this.taken === 0) {
          return false
        }
        return true
      }
      return true
    },
    required () {
      if (this.category && this.category.minimumCourses) {
        return this.category.minimumCourses
      } else {
        return 0
      }
    },
    taken () {
      if (this.category && this.category.coursesUsed) {
        return this.category.coursesUsed
      } else {
        return 0
      }
    },
    needed () {
      if (this.category && this.category.coursesNotPlanned > -1 && this.category.minimumCourses > this.category.coursesUsed) {
        return this.category.minimumCourses - this.category.coursesUsed
      } else {
        return 0
      }
    }
  },

  watch: {
  }
}
</script>
<style>
.red-text {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/app/stream/components/Category.vue